import { render } from "./Sidebar-menu-akahon.vue?vue&type=template&id=22cec151"
import script from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"
export * from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"

import "./Sidebar-menu-akahon.vue?vue&type=style&index=0&id=22cec151&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__